<!-- PAGE TITLE
        ================================================== -->
<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>ADMISSION FORM</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">Admission Form</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>


<section class="container h-100 mb-0 hide-on-mobile">
    <iframe class="pdf"
            src='assets/pdf/form.pdf'
            width="800" height="500">
    </iframe>
</section>

<section class="container h-100 mb-0 d-lg-none d-md-none d-sm-block show-on-mobile text-center">
    <h5>Click the button below to download the PDF</h5>
    <button class="btn btn-lg w-50 fs-3" style="background: #fd7e14;">
        <a class="text-white" href="assets/pdf/form.pdf" target="_blank">Download pdf</a>
    </button>
</section>
